import type { CityConfig } from "../city-template/types";

export const corneliusConfig: CityConfig = {
  city: "Cornelius",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "cornelius",
  route: "/cities/cornelius",
  title: "Emergency Passport Cornelius, NC | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Cornelius, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Mecklenburg County and the Lake Norman area. Get your passport fast with Fast Passport Center.",
  h1: "Emergency & Expedited Passport Services in Cornelius, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Cornelius and Lake Norman area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Cornelius%20North%20Carolina%20scenic%20Lake%20Norman%20waterfront%20at%20golden%20hour%20with%20modern%20suburban%20homes%20along%20the%20shoreline%2C%20upscale%20waterfront%20community%20atmosphere%2C%20green%20trees%20and%20rolling%20hills%20of%20Mecklenburg%20County%2C%20warm%20sunset%20light%20over%20Lake%20Norman%20marina%20with%20boats%2C%20clean%20sky%20with%20soft%20clouds%2C%20professional%20landscape%20photography%20with%20warm%20earthy%20tones%20and%20lake%20community%20atmosphere%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=cornelius-hero-nc-001&orientation=landscape",
  heroImageAlt: "Cornelius North Carolina Lake Norman waterfront at golden hour with upscale waterfront homes and marina",
  geoPosition: "35.4868;-80.8601",
  geoPlacename: "Cornelius, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 245 miles from Cornelius via I-85",
  },
  nearbyCitiesZips: [
    { name: "Cornelius", zips: "28031" },
    { name: "Davidson", zips: "28035, 28036" },
    { name: "Huntersville", zips: "28070, 28078" },
    { name: "Mooresville", zips: "28115, 28117" },
    { name: "Charlotte", zips: "28201–28299" },
    { name: "Concord", zips: "28025, 28026, 28027" },
    { name: "Kannapolis", zips: "28081, 28082, 28083" },
    { name: "Denver", zips: "28037" },
    { name: "Lake Norman", zips: "28031, 28036, 28117" },
    { name: "Lincolnton", zips: "28092, 28093" },
    { name: "Stanley", zips: "28164" },
    { name: "Mount Holly", zips: "28120" },
    { name: "Belmont", zips: "28012" },
    { name: "Gastonia", zips: "28052, 28054, 28056" },
    { name: "Harrisburg", zips: "28075" },
    { name: "Matthews", zips: "28104, 28105" },
    { name: "Mint Hill", zips: "28227" },
    { name: "Pineville", zips: "28134" },
    { name: "Statesville", zips: "28625, 28677, 28687" },
    { name: "Troutman", zips: "28166" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Mecklenburg County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Lake Norman Hub", desc: "Serving Cornelius, Davidson, Huntersville, and the Lake Norman communities" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Fast passport renewal in Huntersville, NC", route: "/cities/huntersville" },
    { name: "Emergency passport help in Mooresville, NC", route: "/cities/mooresville" },
    { name: "Urgent passport services in Davidson, NC", route: "/cities/davidson" },
    { name: "Same-day passport help in Concord, NC", route: "/cities/concord-nc" },
    { name: "Passport courier services in Kannapolis, NC", route: "/cities/kannapolis" },
    { name: "Fast passport renewal in Matthews, NC", route: "/cities/matthews" },
    { name: "Passport courier services in Gastonia, NC", route: "/cities/gastonia" },
    { name: "Expedited passport services in Statesville, NC", route: "/cities/statesville" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Cornelius remotely via secure courier. We do not have a walk-in office in Cornelius — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Mecklenburg County and the Lake Norman area travelers.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Mecklenburg County and the Lake Norman metropolitan region",
  serviceAreaIntro: "From the waterfront neighborhoods of Lake Norman to the charming streets of downtown Cornelius, from the college town of Davidson to the growing communities of Huntersville and Mooresville, from the bustling corridors of north Charlotte to the quiet roads of Denver and Stanley — Fast Passport Center serves the entire Cornelius region. We regularly help travelers from the Lake Norman area, Mecklenburg County, and northern Charlotte get their expedited passports fast.",
  nearbyCitiesIntro: "We serve all Cornelius neighborhoods and the surrounding Lake Norman area including Davidson, Huntersville, Mooresville, Charlotte, Concord, Kannapolis, Denver, Lake Norman, Lincolnton, Stanley, Mount Holly, Belmont, Gastonia, Harrisburg, Matthews, Mint Hill, Pineville, Statesville, and Troutman. If you are anywhere in Mecklenburg County, Iredell County, or the Lake Norman metropolitan area, we have you covered for fast passport and expedited passport services.",
  howItWorksIntro: "Most Cornelius travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Cornelius travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays in getting an expedited passport.",
  testimonialsIntro: "Cornelius and Lake Norman travelers trust us when their departure is days away. Here is what some of them have to say about our emergency passport and fast passport services.",
  faqIntro: "Have questions about expedited passports in Cornelius? Here are the most common ones we hear from Mecklenburg County travelers about emergency passport and fast passport processing.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Cornelius international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Laura M.",
      location: "Cornelius, NC",
      rating: 5,
      text: "My passport expired the week before our family trip to the Bahamas. Fast Passport Center had my renewal ready in 28 hours. I never left Cornelius. The expedited passport service was outstanding.",
      service: "Passport Renewal",
    },
    {
      name: "Tom B.",
      location: "Davidson, NC",
      rating: 5,
      text: "Emergency passport for a business trip to London. Got it in 30 hours. Fast Passport Center handled everything — I didn't have to drive to Atlanta. Their fast passport service is the real deal.",
      service: "Emergency Passport",
    },
    {
      name: "Karen S.",
      location: "Huntersville, NC",
      rating: 5,
      text: "First passport for my 14-year-old before our Europe trip. Fast Passport Center walked us through every document and had her passport in 4 days. So easy for Lake Norman families.",
      service: "Child Passport",
    },
    {
      name: "Mark D.",
      location: "Mooresville, NC",
      rating: 5,
      text: "Lost my passport 3 days before a cruise to the Caribbean. Fast Passport Center had a replacement in my hands in 29 hours. Their expedited passport service across the Lake Norman area is unmatched.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "cornelius-1",
      name: "Cornelius Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "20210 W Catawba Ave",
      city: "Cornelius",
      state: "NC",
      zip: "28031",
      phone: "(704) 892-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Cornelius",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Cornelius facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "cornelius-2",
      name: "Davidson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "202 S Main St",
      city: "Davidson",
      state: "NC",
      zip: "28036",
      phone: "(704) 892-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "4 miles south of Cornelius",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Davidson and southern Mecklenburg County. Good for college community residents.",
      icon: "ri-mail-line",
    },
    {
      id: "cornelius-3",
      name: "Huntersville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "16405 N Cross Ave",
      city: "Huntersville",
      state: "NC",
      zip: "28078",
      phone: "(704) 875-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles south of Cornelius",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Mecklenburg County and Huntersville area. Less crowded than Charlotte. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "cornelius-4",
      name: "Mooresville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 E Plaza Dr",
      city: "Mooresville",
      state: "NC",
      zip: "28115",
      phone: "(704) 663-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles north of Cornelius",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Iredell County and Mooresville area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "cornelius-5",
      name: "Mecklenburg County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "832 E 4th St",
      city: "Charlotte",
      state: "NC",
      zip: "28202",
      phone: "(704) 686-0200",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "20 miles south of Cornelius, Courthouse",
      website: "https://www.mecknc.gov/",
      websiteLabel: "Mecklenburg County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "cornelius-6",
      name: "Charlotte Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N Tryon St",
      city: "Charlotte",
      state: "NC",
      zip: "28202",
      phone: "(704) 344-4183",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles south of Cornelius",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Charlotte metro. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Cornelius photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Mecklenburg County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Cornelius applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Mecklenburg County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Cornelius travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Cornelius." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Cornelius address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Cornelius before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Cornelius for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4 hour drive to Atlanta." },
    { q: "How fast can I get an expedited passport in Cornelius?", a: "Fast Passport Center offers expedited passport services in Cornelius in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day standard expedited option provides the best value. Both options include full document review and a dedicated agent to ensure your fast passport is processed correctly." },
    { q: "What is the closest passport agency to Cornelius?", a: "The nearest regional passport agency to Cornelius is the Atlanta Passport Agency, approximately 245 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Cornelius without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Cornelius?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 4 hours from Cornelius — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Mecklenburg County and Lake Norman residents." },
    { q: "Do you serve the entire Lake Norman area for expedited passports?", a: "Absolutely. Fast Passport Center provides expedited passport services throughout the entire Lake Norman metropolitan area including Cornelius, Davidson, Huntersville, Mooresville, Charlotte, Concord, Kannapolis, Denver, Lake Norman, Lincolnton, Stanley, Mount Holly, Belmont, Gastonia, Harrisburg, Matthews, Mint Hill, Pineville, Statesville, and Troutman. Our courier service works seamlessly from any address in Mecklenburg County, Iredell County, and surrounding areas." },
    { q: "Can I expedite a child passport in Cornelius?", a: "Yes. Fast Passport Center expedites child passports in Cornelius for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Mecklenburg County families through the entire fast passport process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Cornelius with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency for an expedited passport?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change. This is how we deliver fast passport and expedited passport services to Cornelius without the long drive." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Cornelius", address: "19725 W Catawba Ave, Cornelius, NC 28031", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Cornelius", address: "20601 W Catawba Ave, Cornelius, NC 28031", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Cornelius", address: "19701 W Catawba Ave, Cornelius, NC 28031", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Davidson", address: "624 Jetton St, Davidson, NC 28036", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Huntersville", address: "16410 Statesville Rd, Huntersville, NC 28078", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Mooresville", address: "569 River Hwy, Mooresville, NC 28117", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Charlotte", address: "10310 E Independence Blvd, Charlotte, NC 28227", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Charlotte", address: "550 S Tryon St, Charlotte, NC 28202", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Huntersville",
      address: "1625 N Cross Ave, Huntersville, NC 28078",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Charlotte North",
      address: "7520 N Tryon St, Charlotte, NC 28262",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Mooresville",
      address: "118 Four Seasons Town Centre, Mooresville, NC 28117",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Iredell County and northern Lake Norman area. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Charlotte South",
      address: "8520 E Independence Blvd, Charlotte, NC 28227",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Charlotte metro and south Mecklenburg area. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "22 miles south of Cornelius",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international airport for the Charlotte metro area. American Airlines hub with direct flights to Europe, Mexico, the Caribbean, and major domestic destinations. Only 30 minutes from Cornelius.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: true,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "65 miles northeast of Cornelius",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for North Carolina residents. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "155 miles east of Cornelius",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Mecklenburg County Register of Deeds',
      description: 'Marriage licenses and records for Mecklenburg County. Apply in person or request certified copies.',
      url: 'https://meckrod.com/',
    },
    {
      label: 'Mecklenburg County Clerk of Superior Court',
      description: 'Divorce records and decrees for Mecklenburg County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/mecklenburg-county/mecklenburg-county-clerk-of-superior-court',
    },
  ],
};